import { RailsFeatureFlag } from '@sls-react/typings/services/rails/session';
import useV1Session from './useV1Session';

export default function useHasFeature(
  feature: RailsFeatureFlag['slug'],
): boolean {
  const { data } = useV1Session();
  const hasFeature = data?.user?.features?.find(f => f.slug === feature);

  return !!hasFeature;
}
